export const textStatus = (status, colorText) => {
    if(status == 'A'){
        if(colorText){
            return ''
        }else{
            return 'ทั้งหมด'
        }
    }else if(status == 'Y'){
        if(colorText){
            return 'bg-green-status'
        }else{
            return 'อนุมัติ'
        }
    }else if(status == 'N'){
        if(colorText){
            return 'bg-red-status'
        }else{
            return 'ไม่อนุมัติ'
        }
    }else if(status == 'W'){
        if(colorText){
            return 'bg-orange-status'
        }else{
            return 'รออนุมัติ'
        }
    }else if(status == 'C'){
        if(colorText){
            return 'bg-gray-status'
        }else{
            return 'ยกเลิก'
        }
    }
}